import { useState } from "react";
import { Settings, HelpCircle, BookOpen } from "lucide-react";
import { RetroWindow } from "./RetroWindow";
import { SERVER_HOST, SERVER_PORT } from "../../lib/api";
import { useI18n } from "../../lib/i18n";

const clients = [["qip", "QIP 2005"], ["miranda", "Miranda"], ["icq2003", "ICQ 2003b"], ["pidgin", "Pidgin"]];
const fill = (s) => s.replace("{host}", SERVER_HOST).replace("{port}", SERVER_PORT);

export const RetroClients = () => {
  const { t } = useI18n();
  const [tab, setTab] = useState("qip");
  return (
    <RetroWindow id="clients" testid="retro-clients-window" title={t("rtClientsT")} icon={<Settings className="h-4 w-4" />}>
      <div className="flex flex-wrap">
        {clients.map(([id, name]) => (
          <button key={id} type="button" onClick={() => setTab(id)} data-testid={`client-tab-${id}`}
            className={`w98-tab ${tab === id ? "active" : ""}`}>{name}</button>
        ))}
      </div>
      <div className="w98-tabpanel" data-testid={`client-guide-${tab}`}>
        <ol className="w98-sunken bg-white p-3 space-y-2">
          {t("clients")[tab].map(fill).map((s, i) => (
            <li key={s} className="flex gap-3"><b className="text-[#000080]">{i + 1}.</b><span>{s}</span></li>
          ))}
        </ol>
      </div>
    </RetroWindow>
  );
};

export const RetroFaq = () => {
  const { t } = useI18n();
  return (
    <RetroWindow id="faq" testid="retro-faq-window" title={t("rtFaqT")} icon={<HelpCircle className="h-4 w-4" />}>
      <div className="w98-sunken bg-white p-2 space-y-1">
        {t("faqs").map(([q, a], i) => (
          <details key={i} className="group">
            <summary data-testid={`faq-trigger-${i}`} className="flex items-center gap-2 px-1 py-1 hover:bg-[#000080] hover:text-white">
              <span className="w98-soft w-4 h-4 text-[11px] leading-none flex items-center justify-center bg-white text-black">
                <span className="group-open:hidden">+</span><span className="hidden group-open:inline">−</span>
              </span>
              <BookOpen className="h-4 w-4 text-[#808000]" />
              {q}
            </summary>
            <p className="pl-12 pr-2 pb-2 pt-1 text-sm leading-relaxed">{a}</p>
          </details>
        ))}
      </div>
    </RetroWindow>
  );
};
